<template>
	<base-content>
		<div class="index-header">
			<div class="header-content flex align-c">
				<el-image class="header-icon"
					:src="require('@/assets/images/index/head-icon.png')"></el-image>
				<el-image class="header-title"
					:src="require('@/assets/images/index/head-title.png')"></el-image>
			</div>
		</div>
		<div class="bg-f2f">
			<div class="bg-lin-ef">
				<div class="width-1280 index-search">
					<div class="search-div flex align-c justify-sb">
						<div class="search-input">
							<el-input v-model="keyWord" placeholder="搜索职位、公司"></el-input>
						</div>
						<div class="search-btn flex align-c justify-c col-fff bold">
							搜索
						</div>
					</div>
					<div class="index-title bold text-c">
						热点产业
						<div class="title-line"></div>
					</div>
					<div class="flex justify-c industry">
						<div class="industry-item" v-for="(item,index) in industryList" :key="index">
							<el-image class="item-img"
								:src="item.img"></el-image>
							<div class="item-title col-fff text-c bold">{{item.name}}</div>
						</div>
					</div>
					<div class="index-title bold text-c">
						热门企业
						<div class="title-line"></div>
					</div>
				</div>
			</div>
			<div class="bg-f2f">
				<div class="width-1280">
					<div class="mb-34">
						<enterpriseModule></enterpriseModule>
						<div class="index-title bold text-c">
							热门课程
							<div class="title-line"></div>
						</div>
						<div class="mt-40">
							<courseModule></courseModule>
						</div>
					</div>
				</div>
			</div>
		</div>
	</base-content>
</template>

<script>
	import baseContent from '@/components/base-content.vue'
	import enterpriseModule from './components/enterprise-module.vue'
	import courseModule from './components/course-module.vue'
	export default{
		components:{ baseContent,enterpriseModule,courseModule },
		data(){
			return{
				keyWord:'',
				industryList:[
					{img:require('@/assets/images/index/1@2x.png'),name:'芯片'},
					{img:require('@/assets/images/index/2@2x.png'),name:'屏幕'},
					{img:require('@/assets/images/index/3@2x.png'),name:'汽车'},
					{img:require('@/assets/images/index/4@2x.png'),name:'新能源'},
				],
				enterpriseList:[],
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
	}
</script>

<style>
	.index-header{
		background: #39546A;
		height: 148px;
	}
	.header-content{
		width: 1280px;
		margin: auto;
		padding-left: 20px;
		height: 100%;
	}
	.header-icon{
		width: 204px;
		height: 80px;
	}
	.header-title{
		width: 516px;
		height: 77px;
		margin-left: 40px;
	}
	.index-search{
		height: 636px;
		padding-top: 54px;
	}
	.search-div{
		width: 1038px;
		height: 54px;
		background: #169BD5;
		border-radius: 12px;
		margin: auto;
		padding: 2px;
		overflow: hidden;
	}
	.search-input{
		height: 50px;
		width: 916px;
	}
	.search-input .el-input__inner{
		height: 50px;
		border-radius: 12px;
		font-size: 18px;
	}
	.search-btn{
		width:calc(100% - 916px);
		height: 100%;
		font-size: 24px;
		line-height: 24px;
		cursor: pointer;
	}
	.index-title{
		margin-top: 48px;
		position: relative;
		font-size: 36px;
		line-height: 50px;
		color: #333;
	}
	.title-line{
		width: 176px;
		height: 12px;
		background: rgba(22,155,213,0.2);
		position: absolute;
		left: 0;
		right: 0;
		bottom: 3px;
		margin: auto;
	}
	.industry{
		margin-top: 30px;
	}
	.industry-item{
		width: 288px;
		height: 238px;
		border-radius: 14px;
		overflow: hidden;
		background: red;
		margin: 0 15px;
		position: relative;
	}
	.item-img{
		width: 288px;
		height: 238px;
	}
	.industry-item .item-title{
		position: absolute;
		top: 166px;
		left: 0;
		right: 0;
		font-size: 28px;
		line-height: 40px;
	}
	.mb-34{
		margin-top: -34px;
	}
	.mt-40{
		margin-top: 40px;
	}
</style>